import React from "react"
import * as styles from "./bottleSlide.module.scss";

const BottleSlide = () => {
  return (
    <div className={styles.bg}>
      <div className={styles.animation_block}>
        <div className={`${styles.btl_container} ${styles.right}`}>
          <div className={styles.bottle_repeat_1}></div>
        </div>
        <div className={`${styles.btl_container} ${styles.left}`}>
          <div className={styles.bottle_repeat_2}></div>
        </div>
        <div className={`${styles.btl_container} ${styles.right}`}>
          <div className={styles.bottle_repeat_3}></div>
        </div>
      </div>
    </div>
  );
};

export default BottleSlide;
